
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-admissions",
      function () {
        return require("private-next-pages/news-admissions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-admissions"])
      });
    }
  